export const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export const MONTH_FULL = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
export const DAYS = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
export const DAYS_SHORT = ["S", "M", "T", "W", "T", "F", "S"];

export const COLORS = {
    DARK_BLUE: "#1e3a6e",
    MID_BLUE: "#2d4f8e",
    GREEN: "#22c55e",
    RED: "#ef4444",
    CANCELLED_RED: "#ef4444",
};

export const attendanceData = {
    "2025-10-05": "completed",
    "2025-10-08": "completed",
    "2025-10-10": "cancelled",
    "2025-10-13": "completed",
    "2025-10-15": "completed",
    "2025-10-20": "completed",
    "2025-10-22": "completed",
};

export const classDetails = [
    { date: "Tuesday, 11 Oct 2025", time: "12:25 pm", status: "completed" },
    { date: "Monday, 10 Oct 2025", time: "12:25 pm", status: "cancelled" },
    { date: "Saturday, 8 Oct 2025", time: "12:25 pm", status: "completed" },
    { date: "Wednesday, 5 Oct 2025", time: "12:25 pm", status: "completed" },
];